import React, { useState } from "react";

interface CustomTooltipProps {
  children: React.ReactNode;
  content: string;
  trigger: "click" | "hover";
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  children,
  content,
  trigger = "hover",
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleButtonClick = () => {
    if (trigger === "click") {
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
      }, 1500);
    }
  };

  const handleHover = () => {
    if (trigger === "hover") {
      setShowTooltip(true);
    }
  };

  const handleNoHover = () => {
    if (trigger === "hover") {
      setShowTooltip(false);
    }
  };

  return (
    <div
      className={showTooltip ? "tooltip tooltip-open" : ""}
      data-tip={content}
    >
      <div
        onClick={handleButtonClick}
        onMouseEnter={handleHover}
        onMouseLeave={handleNoHover}
      >
        {children}
      </div>
    </div>
  );
};

export default CustomTooltip;
